import { useId } from 'react';

const VB = '0 0 24 24';

/** Centro aproximado do path no viewBox 16×16 (check-line.svg). */
const CHECK_CENTER = { x: 8.15, y: 7.5 };
/** Centro do X no viewBox 16×16 (error-line.svg). */
const X_CENTER = { x: 8, y: 8 };

/** Escala do recorte para ~60–70% do diâmetro do disco branco. */
const CHECK_SCALE = 1.22;
const X_SCALE = 1.38;

function useCutoutMaskId(prefix: string) {
  const id = useId().replace(/:/g, '');
  return `${prefix}-${id}`;
}

const CHECK_D =
  'M13.5968 3.16391C13.9686 3.49386 14.0024 4.0627 13.6725 4.43445L7.11804 11.8193C6.70029 12.2899 5.97354 12.3148 5.52455 11.8739L2.62384 9.02483C2.26923 8.67654 2.2641 8.10671 2.6124 7.75209C2.9607 7.39748 3.53052 7.39235 3.88514 7.74065L6.26056 10.0737L12.3263 3.23959C12.6562 2.86784 13.2251 2.83396 13.5968 3.16391Z';

const X_D =
  'M10.8536 5.85355C11.0488 5.65829 11.0488 5.34171 10.8536 5.14645C10.6583 4.95118 10.3417 4.95118 10.1464 5.14645L8 7.29289L5.85355 5.14645C5.65829 4.95118 5.34171 4.95118 5.14645 5.14645C4.95118 5.34171 4.95118 5.65829 5.14645 5.85355L7.29289 8L5.14645 10.1464C4.95118 10.3417 4.95118 10.6583 5.14645 10.8536C5.34171 11.0488 5.65829 11.0488 5.85355 10.8536L8 8.70711L10.1464 10.8536C10.3417 11.0488 10.6583 11.0488 10.8536 10.8536C11.0488 10.6583 11.0488 10.3417 10.8536 10.1464L8.70711 8L10.8536 5.85355Z';

const iconProps = {
  width: 28,
  height: 28,
  viewBox: VB,
  'aria-hidden': true as const,
};

const CIRCLE = { cx: 12, cy: 12, r: 11 };

export function ToastSuccessCutoutIcon() {
  const maskId = useCutoutMaskId('toast-s');
  const t = `translate(12, 12) scale(${CHECK_SCALE}) translate(${-CHECK_CENTER.x}, ${-CHECK_CENTER.y})`;
  return (
    <svg {...iconProps}>
      <defs>
        <mask id={maskId}>
          <rect width="24" height="24" fill="black" />
          <circle cx={CIRCLE.cx} cy={CIRCLE.cy} r={CIRCLE.r} fill="white" />
          <g transform={t}>
            <path d={CHECK_D} fill="black" />
          </g>
        </mask>
      </defs>
      <circle cx={CIRCLE.cx} cy={CIRCLE.cy} r={CIRCLE.r} fill="white" mask={`url(#${maskId})`} />
    </svg>
  );
}

export function ToastErrorCutoutIcon() {
  const maskId = useCutoutMaskId('toast-e');
  const t = `translate(12, 12) scale(${X_SCALE}) translate(${-X_CENTER.x}, ${-X_CENTER.y})`;
  return (
    <svg {...iconProps}>
      <defs>
        <mask id={maskId}>
          <rect width="24" height="24" fill="black" />
          <circle cx={CIRCLE.cx} cy={CIRCLE.cy} r={CIRCLE.r} fill="white" />
          <g transform={t}>
            <path d={X_D} fill="black" />
          </g>
        </mask>
      </defs>
      <circle cx={CIRCLE.cx} cy={CIRCLE.cy} r={CIRCLE.r} fill="white" mask={`url(#${maskId})`} />
    </svg>
  );
}

export function ToastInfoCutoutIcon() {
  const maskId = useCutoutMaskId('toast-i');
  return (
    <svg {...iconProps}>
      <defs>
        <mask id={maskId}>
          <rect width="24" height="24" fill="black" />
          <circle cx={CIRCLE.cx} cy={CIRCLE.cy} r={CIRCLE.r} fill="white" />
          <g transform="translate(12, 12)">
            <rect x="-1.45" y="-5.4" width="2.9" height="8" rx="0.4" fill="black" />
            <circle cx="0" cy="5.35" r="1.5" fill="black" />
          </g>
        </mask>
      </defs>
      <circle cx={CIRCLE.cx} cy={CIRCLE.cy} r={CIRCLE.r} fill="white" mask={`url(#${maskId})`} />
    </svg>
  );
}

/** Centro vertical do bounding box do “!” nas coords locais (haste + ponto). */
const WARN_EXCL_BBOX_CENTER_Y = (-3.85 + (3.35 + 2.25)) / 2;

/** Triângulo grande no viewBox; “!” escalonado junto (centro no baricentro). */
const WARN_TRI = '12,2.85 22.75,20.15 1.25,20.15';
const WARN_EXCL_CENTER_Y = (2.85 + 20.15 + 20.15) / 3;
const WARN_EXCL_SCALE = 0.88;

export function ToastWarningCutoutIcon() {
  const maskId = useCutoutMaskId('toast-w');
  const exclTransform = `translate(12, ${WARN_EXCL_CENTER_Y}) scale(${WARN_EXCL_SCALE}) translate(0, ${-WARN_EXCL_BBOX_CENTER_Y})`;
  return (
    <svg {...iconProps}>
      <defs>
        <mask id={maskId}>
          <rect width="24" height="24" fill="black" />
          <polygon points={WARN_TRI} fill="white" />
          <g transform={exclTransform}>
            <rect x="-1.45" y="-3.85" width="2.9" height="6.1" rx="0.35" fill="black" />
            <rect x="-1.45" y="3.35" width="2.9" height="2.25" rx="0.35" fill="black" />
          </g>
        </mask>
      </defs>
      <polygon points={WARN_TRI} fill="white" mask={`url(#${maskId})`} />
    </svg>
  );
}
